import React, { useMemo } from 'react'
import { TransactionList } from '@components/TransactionList/TransactionList'
import { InputAdornment, Stack, Tab, Tabs, TextField } from '@mui/material'
import { IoSearch } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import TransactionFilter from '@components/TransactionList/TransactionFilter'
import useWalletTransactionHistory from '@plug-core/hooks/useWalletTransactionHistory'

export const TransactionOverview = () => {
  const { t } = useTranslation()

  const {
    activeTab,
    handleTabChange,
    searchToken,
    setSearchToken,
    historyItems,
    swaps,
    exchanges,
  } = useWalletTransactionHistory()

  const transactions = useMemo(() => {
    switch (activeTab) {
      case 0:
        return historyItems
      case 1:
        return swaps
      default:
        return exchanges
    }
  }, [historyItems, swaps, exchanges, activeTab])

  return (
    <Stack flex={1} spacing={2} mt={2} mx={2}>
      <Tabs
        centered
        value={activeTab}
        onChange={(_, value) => handleTabChange(value)}
        sx={{ width: '100%' }}
      >
        <Tab sx={{ flex: 1 }} label={t('transactionHistory.transactionsTab')} />
        <Tab sx={{ flex: 1 }} label={t('transactionHistory.swapsTab')} />
        <Tab sx={{ flex: 1 }} label={t('transactionHistory.convertsTab')} />
      </Tabs>

      {activeTab === 0 && (
        <Stack direction="row" alignItems="center" spacing={1}>
          <TextField
            fullWidth
            placeholder={t('transactionHistory.searchPlaceholder')}
            value={searchToken}
            onChange={(e) => setSearchToken(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IoSearch color="white" size={18} />
                </InputAdornment>
              ),
            }}
            variant="outlined"
            sx={{
              borderRadius: 1,
              border: '2px solid',
              borderColor: 'secondary.light',
            }}
            size="small"
          />

          <TransactionFilter />
        </Stack>
      )}

      <TransactionList transactions={transactions} />
    </Stack>
  )
}
